import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import TransitionsSnackbar from './TransitionsSnackbar';
import ClientProvider from './client';
export default createDemo(import.meta.url, TransitionsSnackbar, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/snackbars/demos/transitions/TransitionsSnackbar.tsx",
    "fileName": "TransitionsSnackbar.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Button from '@mui/material/Button';\nimport Snackbar from '@mui/material/Snackbar';\nimport Fade from '@mui/material/Fade';\nimport Slide from '@mui/material/Slide';\nimport type { SlideProps } from '@mui/material/Slide';\nimport Grow from '@mui/material/Grow';\nimport type { GrowProps } from '@mui/material/Grow';\nimport type { TransitionProps } from '@mui/material/transitions';\n\nfunction SlideTransition(props: SlideProps) {\n  return <Slide {...props} direction=\"up\" />;\n}\n\nfunction GrowTransition(props: GrowProps) {\n  return <Grow {...props} />;\n}\n\nexport default function TransitionsSnackbar() {\n  const [state, setState] = React.useState<{\n    open: boolean;\n    Transition: React.ComponentType<\n      TransitionProps & {\n        children: React.ReactElement<any, any>;\n      }\n    >;\n  }>({\n    open: false,\n    Transition: Fade,\n  });\n\n  const handleClick =\n    (\n      Transition: React.ComponentType<\n        TransitionProps & {\n          children: React.ReactElement<any, any>;\n        }\n      >,\n    ) =>\n    () => {\n      setState({\n        open: true,\n        Transition,\n      });\n    };\n\n  const handleClose = () => {\n    setState({\n      ...state,\n      open: false,\n    });\n  };\n\n  return (\n    <div>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Button onClick={handleClick(GrowTransition)}>Grow Transition</Button>\n      <Button onClick={handleClick(Fade)}>Fade Transition</Button>\n      <Button onClick={handleClick(SlideTransition)}>Slide Transition</Button>\n      <Snackbar\n        open={state.open}\n        onClose={handleClose}\n        slots={{ transition: state.Transition }}\n        message=\"I love snacks\"\n        key={state.Transition.name}\n        autoHideDuration={1200}\n      />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </div>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 69,
        "focusedLines": 11,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Button from '@mui/material/Button';\nimport Snackbar from '@mui/material/Snackbar';\nimport Fade from '@mui/material/Fade';\nimport Slide from '@mui/material/Slide';\nimport type { SlideProps } from '@mui/material/Slide';\nimport Grow from '@mui/material/Grow';\nimport type { GrowProps } from '@mui/material/Grow';\nimport type { TransitionProps } from '@mui/material/transitions';\n\nfunction SlideTransition(props: SlideProps) {\n  return <Slide {...props} direction=\"up\" />;\n}\n\nfunction GrowTransition(props: GrowProps) {\n  return <Grow {...props} />;\n}\n\nexport default function TransitionsSnackbar() {\n  const [state, setState] = React.useState<{\n    open: boolean;\n    Transition: React.ComponentType<\n      TransitionProps & {\n        children: React.ReactElement<any, any>;\n      }\n    >;\n  }>({\n    open: false,\n    Transition: Fade,\n  });\n\n  const handleClick =\n    (\n      Transition: React.ComponentType<\n        TransitionProps & {\n          children: React.ReactElement<any, any>;\n        }\n      >,\n    ) =>\n    () => {\n      setState({\n        open: true,\n        Transition,\n      });\n    };\n\n  const handleClose = () => {\n    setState({\n      ...state,\n      open: false,\n    });\n  };\n\n  return (\n    <div>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Button onClick={handleClick(GrowTransition)}>Grow Transition</Button>\n      <Button onClick={handleClick(Fade)}>Fade Transition</Button>\n      <Button onClick={handleClick(SlideTransition)}>Slide Transition</Button>\n      <Snackbar\n        open={state.open}\n        onClose={handleClose}\n        slots={{ transition: state.Transition }}\n        message=\"I love snacks\"\n        key={state.Transition.name}\n        autoHideDuration={1200}\n      />\n"
      ],
      [
        "span",
        "frame",
        "    </div>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 56
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Button"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "onClick"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-en",
                "handleClick"
              ],
              "(",
              [
                "span",
                "pl-smi di-jv",
                "GrowTransition"
              ],
              ")",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">Grow Transition</",
              [
                "span",
                "pl-c1 di-jsx",
                "Button"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 57
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Button"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "onClick"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-en",
                "handleClick"
              ],
              "(",
              [
                "span",
                "pl-smi di-jv",
                "Fade"
              ],
              ")",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">Fade Transition</",
              [
                "span",
                "pl-c1 di-jsx",
                "Button"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 58
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Button"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "onClick"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-en",
                "handleClick"
              ],
              "(",
              [
                "span",
                "pl-smi di-jv",
                "SlideTransition"
              ],
              ")",
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">Slide Transition</",
              [
                "span",
                "pl-c1 di-jsx",
                "Button"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 59
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Snackbar"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 60
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "open"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "state"
              ],
              ".",
              [
                "span",
                "pl-smi di-jv",
                "open"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 61
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "onClose"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "handleClose"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 62
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "slots"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "transition"
              ],
              ": ",
              [
                "span",
                "pl-smi di-jv",
                "state"
              ],
              ".",
              [
                "span",
                "pl-smi di-jv",
                "Transition"
              ],
              " }",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 63
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "message"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "I love snacks",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 64
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "key"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "state"
              ],
              ".",
              [
                "span",
                "pl-smi di-jv",
                "Transition"
              ],
              ".",
              [
                "span",
                "pl-c1 di-jv",
                "name"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 65
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "autoHideDuration"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "1200"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 66
            },
            "      />"
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 69,
    "focusedLines": 11,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Button",
      "@mui/material/Snackbar",
      "@mui/material/Fade",
      "@mui/material/Slide",
      "@mui/material/Grow",
      "@mui/material/transitions"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
